import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export default function Img({ src, alt }) {
	return <GatsbyImage image={getImage(src)} alt={alt} />;
}
